// extracted by mini-css-extract-plugin
export var articleBody = "layout-module--article-body--304ff";
export var container = "layout-module--container--513e3";
export var content = "layout-module--content--eb47e";
export var editor = "layout-module--editor--a3565";
export var home = "layout-module--home--29f27";
export var noSidebar = "layout-module--no-sidebar--2d3e5";
export var sidebar = "layout-module--sidebar--62cd1";
export var withSidebar = "layout-module--with-sidebar--e21aa";